import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IOrganization, IUser, IUserResponse } from 'types/models/User';
import { ISignIn } from 'types/models/Auth';

/**
 * Интерфейс состояния пользователя в store
 */
export interface IUserState {
    isLoggedIn: boolean;
    auth: ISignIn | null;
    data: IUser | null;
}

const initialState = { isLoggedIn: false } as IUserState;

export const userSlice = createSlice({
  name: 'eventUser',
  initialState,
  reducers: {
    /**
     * Устанавливает флаг авторизации пользователя
     * @param state - текущее состояние
     * @returns новое состояние с установленным флагом авторизации
     */
    makeLogged: state => ({
      ...state,
      isLoggedIn: true
    }),
    /**
     * Обновляет данные авторизации пользователя
     * @param state - текущее состояние
     * @param action - действие с данными авторизации
     * @param action.payload - данные авторизации
     * @returns новое состояние с обновленными данными авторизации
     */
    updateUserAuth: (state, { payload }: { payload: ISignIn }) => ({
      ...state,
      auth: { ...payload }
    }),
    /**
     * Обновляет данные пользователя в store
     * @param state - текущее состояние
     * @param action - действие с данными пользователя
     * @param action.payload - данные пользователя из ответа API
     * @param action.payload.user - объект пользователя с массивом организаций
     */
    updateUserData: (state, action: PayloadAction<{ user: IUserResponse, organization: IOrganization}>) => {
      const { user, organization } = action.payload;

      state.data = {
        ...user,
        organization
      };
    },
    /**
     * Сбрасывает состояние пользователя к начальному
     * @returns начальное состояние
     */
    remove: () => initialState
  }
});

export const {
  updateUserAuth,
  updateUserData,
  remove,
  makeLogged
} = userSlice.actions;

export default userSlice.reducer;
